export default __webpack_public_path__ + "static/media/add_blue.3a9dd384.svg";